import React from 'react';
import { ICON_BUTTON_TEXT_CLASS, iconButton } from '@noths/polaris-client-styles';
import type { XOR } from '@noths/polaris-dev-ts-recipes';

import { DRAWER_HEADER_CLASSNAME, DRAWER_HEADER_TITLE_CLASSNAME } from '../constants/classNames';
import * as styles from '../styles/DrawerHeader.styles';
import { CloseButton } from 'client-ribbons-design-system/components/elements/IconButtons/CloseButton';
import { IconArrowBack } from 'client-ribbons-design-system/components/foundations/Iconography/IconArrowBack';

const ICON_SIZE = 24;

interface WithBackButton {
  onBack?: VoidFunction;
}
interface WithCloseButton {
  onClose?: VoidFunction;
}

interface DrawerHeaderBaseProps {
  disabled?: boolean;
  headingLevel?: 'h2' | 'h3';
  index?: number;
  title: string;
}

export type DrawerHeaderProps = DrawerHeaderBaseProps & XOR<WithBackButton, WithCloseButton>;

export const DrawerHeader = ({
  disabled,
  headingLevel: Heading = 'h3',
  index,
  onBack,
  onClose,
  title,
}: DrawerHeaderProps) => (
  <header className={DRAWER_HEADER_CLASSNAME} css={styles.header}>
    {onBack && (
      <button
        css={[iconButton, styles.backBtn]}
        data-testid={`back-button-${index}`}
        disabled={disabled}
        onClick={onBack}
      >
        <IconArrowBack height={ICON_SIZE} width={ICON_SIZE} />
        <span className={ICON_BUTTON_TEXT_CLASS}>Back</span>
      </button>
    )}
    <Heading className={DRAWER_HEADER_TITLE_CLASSNAME}>{title}</Heading>
    {onClose && (
      <CloseButton
        aria-label="Close"
        css={[iconButton, styles.closeBtn]}
        disabled={disabled}
        onClick={onClose}
        size="large"
      />
    )}
  </header>
);
